import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  constructor(private readonly httpClient: HttpClient) {}

  getAssociatedDocument(
    quoteId: number,
    docId: number
  ): Observable<ArrayBuffer> {
    return this.httpClient.get(
      `${environment.middlewareUrl}/document/quote/${quoteId}/${docId}`,
      { responseType: 'arraybuffer' }
    );
  }
}
